const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.072,4.931A10.022,10.022,0,0,0,3.3,17.021L1.88,22.213,7.192,20.82a10.01,10.01,0,0,0,4.788,1.219h0A10.024,10.024,0,0,0,19.072,4.931ZM11.984,20.347h0a8.32,8.32,0,0,1-4.239-1.161l-.3-.18-3.152.827.842-3.074-.2-.315a8.329,8.329,0,1,1,7.055,3.9Zm4.569-6.237c-.251-.126-1.482-.731-1.711-.815s-.4-.125-.563.126-.647.814-.793.981-.292.188-.543.063a6.835,6.835,0,0,1-2.013-1.243,7.572,7.572,0,0,1-1.393-1.734c-.146-.251,0-.373.11-.511a7.071,7.071,0,0,0,.626-.857.46.46,0,0,0-.021-.438c-.062-.125-.563-1.358-.772-1.859s-.409-.422-.563-.43-.313-.009-.48-.009a.921.921,0,0,0-.668.314,2.807,2.807,0,0,0-.876,2.088,4.869,4.869,0,0,0,1.022,2.59,11.17,11.17,0,0,0,4.277,3.78,14.09,14.09,0,0,0,1.428.528,3.431,3.431,0,0,0,1.577.1,2.578,2.578,0,0,0,1.689-1.19,2.087,2.087,0,0,0,.146-1.191C16.97,14.3,16.8,14.235,16.553,14.11Z",
    style: {
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappSmall);
export default __webpack_public_path__ + "static/media/whatsapp_small.84c1e9b260eb4877166d195d86ab2815.svg";
export { ForwardRef as ReactComponent };